<template>
    <div class="page_indicator_bullet">
        <span :class="{'active' : pageNumberIndicator == 1}"
        :style="{
            'background': colors.theme == 'dark' ? '#fff' : '#000'
        }"    
        ></span>
        <span :class="{'active' : pageNumberIndicator == 2}"
        :style="{
            'background': colors.theme == 'dark' ? '#fff' : '#000'
        }"             
        ></span>
        <span :class="{'active' : pageNumberIndicator == 3}"
        :style="{
            'background': colors.theme == 'dark' ? '#fff' : '#000'
        }"             
        ></span>
        <span :class="{'active' : pageNumberIndicator == 4}"
        :style="{
            'background': colors.theme == 'dark' ? '#fff' : '#000'
        }"             
        ></span>
    </div>
</template>

<script>
export default {
    name: 'PageIndicatorBullets',
    props:{
        pageNumberIndicator: Number
    },

    data: () => ({colors:{}}),
    created(){
        // console.log('pageNumberIndicator PageIndicatorBullets: ', this.pageNumberIndicator)
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
}
</script>

<style lang="scss" scoped>
.page_indicator_bullet{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 8px 0 0 0;

    span{
        border-radius: 100px;
        padding: 3px;
        display: inline-block;
        margin: 0px 3px;
    }
    span:not(.active){
        opacity: .2;

    }
    
    .active{
        // background: rgba($alpha: 1.0);
    }
}
</style>
